import i18n from 'i18next'

import { TimeInterval } from 'models/subscriptionsApi'

import {
  AppName,
  Currency,
  DAYS_IN_MONTH,
  DAYS_IN_WEEK,
  Language,
  UnsubscribeReason,
} from 'root-constants'

import { RETENTION_FLOW_V2_CONFIGS } from './constants'

const DAYS_IN_YEAR = 365

const DAYS_IN_INTERVAL = {
  [TimeInterval.DAY]: 1,
  [TimeInterval.WEEK]: DAYS_IN_WEEK,
  [TimeInterval.MONTH]: DAYS_IN_MONTH,
  [TimeInterval.YEAR]: DAYS_IN_YEAR,
}

export const formatAmount = (amount: number, currency: string): string => {
  if (currency.toLowerCase() === Currency.KRW) {
    return `${Math.trunc(amount)}`
  }

  return amount.toFixed(2)
}

export const getDailyPrice = (
  price: number,
  interval: string,
  intervalCount: number,
): number => {
  const days = (DAYS_IN_INTERVAL[interval] || 0) * intervalCount

  return days ? price / days : 0
}

export const roundToNinetyNineCents = (price: number): number =>
  price ? Math.ceil(price) - 0.01 : price

export const getReasonAnswerText = (copyKey: string, answer: string): string =>
  i18n.t(
    answer === UnsubscribeReason.NO_REASON
      ? `${copyKey}.skip`
      : `${copyKey}.reasons.answers.${answer}`,
    { lng: Language.EN },
  )

export const getCancellationReason = (
  appName: AppName,
  answer: string,
): string => {
  const config = RETENTION_FLOW_V2_CONFIGS[appName]

  return config && answer ? getReasonAnswerText(config.copyKey, answer) : answer
}
